import { css } from '@emotion/react';

const globalStyles = css`
  @font-face {
    font-family: 'Montserrat';
    font-weight: 100 900;
    font-display: swap;
    font-style: normal;
    font-named-instance: 'Regular';
    src: url(/fonts/Montserrat-Variable.woff2) format('woff2');
  }

  :root {
    --orange: rgb(244, 120, 32);
    --orange--hover: rgb(202, 92, 15);
    --blue: rgb(50, 74, 93);
    --blue--hover: rgb(27, 49, 66);
    --gray: rgb(131, 112, 112);
    --transition-gray: rgb(126, 107, 107);
  }

  body,
  html {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    scroll-behavior: smooth;
  }

  * {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  ul,
  li {
    margin: 0;
  }
`;

export { globalStyles };
export default globalStyles;
